import React, { Fragment } from 'react';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import CtaSection from '../../components/CtaSection/CtaSection';
import Bg from '../../images/bg/page_bg01.jpg';
import './steps.css';
import androidImg from "../../images/Truslypay_imgs/android.png";
import iosImg from "../../images/Truslypay_imgs/apple.png";

const faqSections = [
  {
    key: "A",
    title: "Getting Started",
    subtitle: "Begin your journey.",
    faqs: [
      {
        q: "How do I register?",
        a: (
          <>
            <p style={{ marginBottom: "14px", color: "#555", lineHeight: "1.6" }}>
              You can register on the Tigris Pay mobile app using your email address and mobile number,
              then create a secure password.
            </p>

            <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              {/* App Store */}
              <a
                href="https://apps.apple.com/us/app/tigrispay/id6754586181"
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "inline-block",
                  textDecoration: "none",
                }}
              >
                <img src={iosImg} alt="Download on App Store" style={{ height: "45px", width: "auto" }} />
              </a>

              {/* Play Store */}
              <a
                href="https://play.google.com/store/apps/details?id=com.org.tigris"
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "inline-block",
                  textDecoration: "none",
                }}
              >
                <img src={androidImg} alt="Get it on Google Play" style={{ height: "45px", width: "auto" }} />
              </a>
            </div>
          </>

        )
      },
      {
        q: "Which ID documents are required for onboarding?",
        a: "You are required to upload a valid government-issued ID such as a passport, driving licence, or national ID card, along with proof of address, depending on regulatory requirements."
      },
      {
        q: "What information do I need to send money?",
        a: "After registration you will require beneficiary’s information, including name, bank details, and destination country and purpose of transfer."
      },
      {
        q: "How do I send money?",
        a: "Log in to your account, enter the transfer amount, add beneficiary details, choose a payment method, and confirm the transfer."
      },
      {
        q: "Can I visit your store to make a cash transfer?",
        a: "Tigris Pay is a digital service. All transfers are made online via mobile app."
      },
      {
        q: "Can I track my transfer?",
        a: "Yes. You can track your transfer status from view history on the app."
      },
      {
        q: "Can I send money through somebody else's bank account?",
        a: "No. Transfers must be funded from a bank account that belongs to you."
      },
      {
        q: "Can I send money through a joint bank account?",
        a: "Yes, as long as your name appears on the joint bank account."
      }
    ]
  },

  {
    key: "B",
    title: "Fees & Charges",
    subtitle: "Understanding your costs.",
    faqs: [
      {
        q: "How are transfer fees calculated?",
        a: "Transfer fees depend on the currencies involved, destination country, and payment method. The exact fee is shown before you confirm the transfer."
      },
      {
        q: "Will there be a discount if I transfer to the same beneficiary repeatedly?",
        a: "No. Any available promotions or discounts will be applied automatically and shown before confirmation."
      },
      {
        q: "How can I check fees before sending money?",
        a: "You can view applicable fees and exchange rates during the transfer setup, before making payment."
      }
    ]
  },

  {
    key: "C",
    title: "Sending Limits & Payment Options",
    subtitle: "How you can pay & how much you can send ?",
    faqs: [
      {
        q: "Is there a minimum or maximum amount I can send?",
        a: "Yes. The minimum transfer amount is £20. Maximum limits may apply in accordance with applicable terms and conditions."
      },
      {
        q: "Is an ID document required for every transfer?",
        a: "No. ID verification is generally required during onboarding or when requested for compliance or additional verification purposes, not for every transfer."
      },
      {
        q: "Can I fund my transaction using a credit card?",
        a: "Available payment methods currently are Open Banking, Manual Bank Transfer and payment via Debit card. Available payment methods may change."
      }
    ]
  },

  {
    key: "D",
    title: "Transfer Timing & Delivery",
    subtitle: "How fast will your money arrive?",
    faqs: [
      {
        q: "How long does a transfer take?",
        a: "Direct-to-bank transfers are processed instantly or on the same day. However, transfer times may vary depending on the destination, payout method, and local banking hours."
      },
      {
        q: "Do transfers process on weekends or public holidays?",
        a: "Processing may be delayed during weekends or public holidays, depending on the receiving country and bank."
      },
      {
        q: "My transfer status shows “Received,” but the money is not in the beneficiary’s account. What should I do?",
        a: "Please allow some additional processing time. If the delay continues, contact customer support at hello@tigrispay.com with your transaction reference."
      },
      {
        q: "What happens if my payment is rejected or fails?",
        a: "If a payment is rejected, the funds will be returned to the original payment method, subject to standard processing times."
      },
      {
        q: "Will I be notified when my transfer is completed?",
        a: "Yes. You will receive a notification via email once your transfer is successfully completed."
      }
    ]
  },

  {
    key: "E",
    title: "Fixing Mistakes",
    subtitle: "Made an error? We’ve got you.",
    faqs: [
      {
        q: "What if I enter incorrect beneficiary details such as name and bank details?",
        a: "Incorrect details may cause delays, rejection, or return of funds. Please contact customer support at hello@tigrispay.com immediately if you notice an error."
      },
      {
        q: "Can I cancel or change a transfer after initiating it?",
        a: "Changes or cancellations are only possible if the transfer has not yet been processed."
      }
    ]
  },

  {
    key: "F",
    title: "Safety & Verification",
    subtitle: "Security that protects you.",
    faqs: [
      {
        q: "Are you regulated?",
        a: "Yes. Tigris Pay is a trading name of Fast Track Money Transfer who is regulated by the Financial Conduct Authority (FCA) in the UK."
      },
      {
        q: "Why do you ask for identity verification?",
        a: "Identity verification helps us comply with regulations and protects your account from security threads."
      },
      {
        q: "Is my personal and financial data secure?",
        a: "We do not store your financial information but your personal information is encrypted and protected."
      }
    ]
  },

  {
    key: "G",
    title: "Account & App Support",
    subtitle: "Managing your account.",
    faqs: [
      {
        q: "I forgot my password. How can I reset it?",
        a: "Tap on “Forgot Password” on the login screen and follow the instructions."
      },
      {
        q: "How can I upload another ID document?",
        a: "Log in to the app, go to Profile → ID Documents, and upload the required document."
      },
      {
        q: "What should I do if my existing ID has expired?",
        a: "Please upload a valid replacement ID as soon as possible to avoid any service disruption."
      },
      {
        q: "Do I need to confirm the purpose of my transfer?",
        a: "Yes. We may ask you to confirm the purpose of your transfer, such as tuition fees, payroll, or family support."
      },
      {
        q: "What is a Source of Funds document?",
        a: "A source of funds document may include a bank statement or a payslip."
      },
      {
        q: "What happens if I don’t provide the required documents?",
        a: "If the required documents are not provided, we will be unable to process your transaction."
      },
      {
        q: "Do you share my personal data with third parties?",
        a: "We only share personal data with trusted partners who provide technical or administrative services or when required by law."
      },
      {
        q: "Can I delete my existing ID and upload a new one?",
        a: "Yes. You can request to replace your existing ID through your account or you can reach us via the app or website contact form or by emailing hello@tigrispay.com."
      },
      {
        q: "How can I contact customer support?",
        a: "You can reach us via the app, the website contact form, or by emailing hello@tigrispay.com."
      }
    ]
  }
];


const GeneralFaq = () => {
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />

        <section
          className="page-title pt-100 pb-5 text-center text-white"
          style={{ backgroundImage: `url(${Bg})`, backgroundSize: 'cover' }}
        >
          <div className="container">
            <h2 className="display-5 fw-bold">FAQs</h2>
          </div>
        </section>

        <section className="py-5 bg-light container">
          <div className="container">

            {faqSections.map((section) => (
              <div key={section.key} className="mb-5">

                {/* SECTION TITLE */}
                <div className="mb-3">
                  <h4 className="fw-bold text-dark">
                    {section.title}
                  </h4>
                  <p className="text-muted mb-4">
                    {section.subtitle}
                  </p>
                </div>

                {/* QUESTIONS */}
                <div className="accordion" id={`faq-${section.key}`}>
                  {section.faqs.map((faq, i) => (
                    <div className="accordion-item mb-2" key={i}>
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button collapsed"
                          data-bs-toggle="collapse"
                          data-bs-target={`#${section.key}-${i}`}
                        >
                          {faq.q}
                        </button>
                      </h2>

                      <div
                        id={`${section.key}-${i}`}
                        className="accordion-collapse collapse"
                        data-bs-parent={`#faq-${section.key}`}
                      >
                        <div className="accordion-body">
                          {faq.a}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

              </div>
            ))}

          </div>
        </section>


        <CtaSection />
        <Footer />
        <Scrollbar />
      </div>
    </Fragment>
  );
};

export default GeneralFaq;
